import React from "react";

const DetailsModal = ({ translate, app, onClose }) => {
  return (
    <div className="modal" style={{ display: "flex" }}>
      <div className="modal-content">
        <h3>{translate("appDetails")}</h3>
        <p>
          <strong>{translate("name")}:</strong> {app.name}
        </p>
        <p>
          <strong>{translate("status")}:</strong> {app.status}
        </p>
        <p>
          <strong>{translate("domain")}:</strong> {app.domain || "-"}
        </p>
        <p>
          <strong>{translate("ns")}:</strong> {app.ns || "-"}
        </p>
        <button onClick={onClose}>{translate("close")}</button>
      </div>
    </div>
  );
};

export default DetailsModal;